/* eslint-disable */
export default {
  _background_bubbles: 'background_bubbles',
  _fish_enter_scene: 'fish_enter_scene',
  _fish_music: 'fish_music',
  _jaws: 'jaws',
  _touch_fish: 'touch_fish',
}